import {
  scenarioData,
  scenarioDefault
} from './data'

export const selectedScenario = Object.assign({}, scenarioDefault)

// Essential functions
export function getScenario () {
  return scenarioData.filter(scenario =>
    Object.keys(selectedScenario).every(setting =>
      scenario[setting] === selectedScenario[setting]))[0]
}

export function resetScenario () {
  for (const setting in scenarioDefault) {
    selectedScenario[setting] = scenarioDefault[setting]
  }
}

export function setScenario(setting, value) {
  selectedScenario[setting] = value
}